
import Vue from 'vue'
import ImportLoading from '@/components/import/ImportLoading.vue'
import ImportConfirmation from '@/components/import/ImportConfirmation.vue'
import importPersonalAccountGisGkh from '@/connectors/personal-accounts/import-personal-account-gis-gkh'
import { IPersonalAccountImportGisGkh } from '@/types/personal-accounts'
import { ModalIds } from '@/components/popup/modal-ids'
import SelectImportFile from '@/components/import/SelectImportFile.vue'

export default Vue.extend({
  name: 'PersonalAccountsImportPopup',
  components: { SelectImportFile, ImportLoading, ImportConfirmation },
  props: {
    idSelectedOrganization: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      ModalIds,
      file: null,
      importTab: 1,
      importPersonalAccounts: [],
      personalAccountData: {} as IPersonalAccountImportGisGkh,
      fields: [
        {
          key: 'account_global_id',
          label: 'Л/С',
          sortable: true
        },
        {
          key: 'account_holder',
          label: 'ФИО'
        },
        {
          key: 'information_source',
          label: 'Источник информации'
        }
      ],
      errorMessage: ''
    }
  },
  methods: {
    // импорт лицевых счетов
    importFromGisGkh (file) {
      if (file) {
        const formdata: any = new FormData()
        formdata.append('moid', this.idSelectedOrganization)
        formdata.append('file', file)
        importPersonalAccountGisGkh(formdata)
          .then(res => {
            console.log('file', res)
            this.importPersonalAccounts = res.data
            this.personalAccountData = {
              moid: this.idSelectedOrganization,
              data: res.data
            }
            this.importTab = 2
          }).catch(e => {
            console.error(e.response)
            // @ts-ignore
            this.$showErrorToast(e.response.data.message)
          })
      }
    },
    // подтверждение правильности данных лицевых счетов и отправка
    confirmationImportFromGisGkh () {
      this.importTab = 3
      importPersonalAccountGisGkh(this.personalAccountData)
        .then(response => {
          console.log('impacc', response.data)
          this.importTab = 4
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$bvModal.show('errorModal')
          this.importTab = 1
        })
    }
  }
})
